export default __webpack_public_path__ + "static/media/closeRoad.be4ebdb7.svg";